// Les paliers de bien-être : chaque état a ses effets sur l'énergie, l'apprentissage et les envies.
import type { TextKey } from './fr';

export type MoodId = 'forme' | 'normal' | 'morose' | 'coupDeMou' | 'epuisement';

export interface MoodDef {
  id: MoodId;
  label: TextKey;
  effect: TextKey;
  /** Bien-être minimal pour être dans cet état. */
  min: number;
  /** Multiplicateurs de la vitesse de retour de l'énergie, de l'expérience et des envies d'achats. */
  regen: number;
  xp: number;
  temptation: number;
}

/** Du meilleur état au pire : le premier dont le minimum est atteint s'applique. */
export const MOODS: MoodDef[] = [
  { id: 'forme', label: 'mood.forme.label', effect: 'mood.forme.effect', min: 70, regen: 1.15, xp: 1.1, temptation: 1 },
  { id: 'normal', label: 'mood.normal.label', effect: 'mood.normal.effect', min: 40, regen: 1, xp: 1, temptation: 1 },
  { id: 'morose', label: 'mood.morose.label', effect: 'mood.morose.effect', min: 25, regen: 0.75, xp: 0.9, temptation: 1 },
  {
    id: 'coupDeMou',
    label: 'mood.coupDeMou.label',
    effect: 'mood.coupDeMou.effect',
    min: 10,
    regen: 0.75,
    xp: 0.9,
    temptation: 2,
  },
  {
    id: 'epuisement',
    label: 'mood.epuisement.label',
    effect: 'mood.epuisement.effect',
    min: 0,
    regen: 0.75,
    xp: 0.9,
    temptation: 2,
  },
];
